import { EnumValue } from '../types/EnumType';

type TipoSituacaoDebito = EnumValue;

export const TipoSituacaoDebitoEnum: TipoSituacaoDebito[] = [
  { codigo: 'N', descricao: 'Sem débitos' },
  { codigo: 'R', descricao: 'Débitos a vencer' },
  { codigo: 'V', descricao: 'Débitos vencidos' }
];
